export const ID_OTHER_RITUAL_RELIGIOUS = '0';
